export const AUTH0_DOMAIN = process.env.REACT_APP_AUTH0_DOMAIN ?? '';
export const AUTH0_CLIENT_ID = process.env.REACT_APP_AUTH0_CLIENT_ID ?? '';
export const AUTH0_AUDIENCE = process.env.REACT_APP_AUTH0_AUDIENCE ?? '';
export const AUTH0_CALLBACK_URL = `${window.location.protocol}//${window.location.host}`;
export const AUTH0_LOGOUT_URL = `${window.location.protocol}//${window.location.host}`;
export const CHATPLUS_URL = 'https://app.chatplus.jp';
export const API_HOST = process.env.REACT_APP_API_HOST || '';

/**
 * 予定進捗推移のAI予測機能に関するヘルプページのURL（外部リンク）
 */
export const AI_PREDICTION_PLAN_PROGRESS_TRANSITION_HELP_URL =
  'https://clarislink-support.com/%e3%80%90%e6%93%8d%e4%bd%9c%e3%82%ac%e3%82%a4%e3%83%89%e3%80%91%e6%9c%aa%e6%9d%a5%e3%81%ae%e3%82%a2%e3%82%a6%e3%83%88%e3%82%92%e4%ba%88%e6%b8%ac%e3%81%99%e3%82%8b/';
/**
 * 予定登録のAI予測機能に関するヘルプページのURL（外部リンク）
 */
export const AI_PREDICTION_PLAN_SETTINGS_HELP_URL =
  'https://clarislink-support.com/%e3%80%90%e6%93%8d%e4%bd%9c%e3%82%ac%e3%82%a4%e3%83%89%e3%80%91%e6%9c%aa%e6%9d%a5%e3%81%ae%e3%82%a2%e3%82%a6%e3%83%88%e3%82%92%e4%ba%88%e6%b8%ac%e3%81%99%e3%82%8b/';

export const strictMode =
  process.env.NODE_ENV === 'development' &&
  process.env.REACT_APP_STRICT_MODE === 'true';

export const isDebugSentry = process.env.REACT_APP_SENTRY_DEBUG_MODE === 'true';

export const isEnabledSentry =
  process.env.NODE_ENV === 'production' ||
  (process.env.NODE_ENV === 'development' && isDebugSentry);

/**
 * ClarisLinkで基準となる開始日
 * @link https://github.com/DKClaris/claris-general/issues/4153
 */
export const serviceStartDate = '2019-01-01';

export const SIS_TYPE_UPDATE_DATES = {
  v1: '2023-09-14T16:20:00+09:00',
};

/**
 * Issue #6154 派生画面の表示項目パターン — ヘッダー Update アイコン表示用 PRD 日付（yyyy-MM-dd）
 * @see https://github.com/DKClaris/claris-general/issues/6154
 */
export const DERIVATIVE_COLS_PATTERN_UPDATE_ICON_PRD_DATE = '2026-05-18';
/**
 * ヘッダーの高さ（px）
 * Material-UIのToolbarのデフォルト高さを上書き
 */
export const HEADER_HEIGHT = 56;

/**
 * MKS 非契約企業など、商圏系の表示項目を隠す必要がある共有グループコード
 * @see https://github.com/DKClaris/claris-general/issues/6212
 */
export const RESTRICTED_KYOYU_GROUP_CODES = ['13076001'] as const;

/**
 * 「自店〇〇」に該当する表示項目コードの先頭（API の code が `jiten…` のものをまとめて除外）
 */
export const JITEN_FIELD_CODE_PREFIX = 'jiten' as const;

/**
 * 商圏系表示項目コードの先頭（特定共有グループでは一覧・お気に入りから除外）
 */
export const SYOKEN_FIELD_CODE_PREFIX = 'syoken' as const;
